import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#FFFFFF",
		d: "M17.9,4.02L15.98,2.1c-1-1-2.62-1-3.62,0L2.06,12.4L2,12.53V18h5.47l0.14-0.06L17.9,7.65 C18.9,6.65,18.9,5.02,17.9,4.02z M3,17v-3.67L6.67,17H3z M3.48,12.4l7.37-7.37l4.13,4.13L7.6,16.52L3.48,12.4z M17.19,6.94 l-1.51,1.51l-4.13-4.13l1.51-1.51c0.61-0.61,1.6-0.61,2.21,0l1.92,1.92C17.8,5.34,17.8,6.33,17.19,6.94z"
	})
});
export default SvgEdit;
